import { SIZE_15MB, ALLOWED_EXTENSIONS } from './constants';

export const isValidFileSize = (file: File): boolean => file.size <= SIZE_15MB;

export const isValidFileExtension = (file: File): boolean => ALLOWED_EXTENSIONS.includes(file.name.split('.').at(-1) || '');

export const isNoDuplicateFileName = (files: File[], file: File): boolean => files
    .filter(({ name }) => name === file.name)
    .length < 2;

export const isFileValid = (files: File[], file: File): boolean => isValidFileSize(file)
    && isValidFileExtension(file)
    && isNoDuplicateFileName(files, file);

export const checkRequiredDate = (value: string | null): boolean => {
    const [year = '', month = '', day = ''] = (value || '').split('-');

    return Boolean(day && month && year);
};

export const getFileErrorTk = (files: File[], file: File): string | void => {
    if (!isNoDuplicateFileName(files, file)) {
        return 'validation.file.duplicate';
    }

    if (!isValidFileSize(file)) {
        return 'validation.file.size';
    }

    if (!isValidFileExtension(file)) {
        return 'validation.file.format';
    }
};
